import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import moment from 'moment';
import dayjs from 'dayjs';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class DateRangePickerComponent {
  selected: any;
  alwaysShowCalendars: boolean;

  @Output() sendSelectedRange = new EventEmitter<any>();
  @Input() set setSelectedDate(selected: any) {
    this.selected = selected;
  }
  @ViewChild(DaterangepickerDirective, { static: false }) picker!: DaterangepickerDirective;

  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(7, 'days'), moment()],
    'Last 30 Days': [moment().subtract(30, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment()],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
    'Last 6 Months': [moment().subtract(6, 'months'), moment().endOf('day')],
    'Last 12 Months': [moment().subtract(12, 'months'), moment().endOf('day')]
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.alwaysShowCalendars = true;
  }

  maxDate: any = dayjs().toISOString();

  onRangeClicked(event: any) {
    this.picker.hide();
    if (event.dates[0] != null && event.dates[1] != null) {

      let data = {
        startDate: event.dates[0],
        endDate: event.dates[1]
      };

      this.selected = data;

      data = {
        startDate: this.convertToPayloadDate(event.dates[0]),
        endDate: this.convertToPayloadDate(event.dates[1])
      };

      this.sendSelectedRange.emit(data);
    }
  }

  onDatesUpdated(event: any) {
    if (event?.target?.value) {
      let dates = event?.target?.value.split("-");
      if (dates.length == 2) {
        event.startDate = dayjs(new Date(dates[0]));
        event.endDate = dayjs(new Date(dates[1]));

        this.selected.startDate = event.startDate;
        this.selected.endDate = event.endDate;
      }
    }
    if (event.startDate != null && event.endDate != null) {
      let data = {
        startDate: this.convertToPayloadDate(event.startDate),
        endDate: this.convertToPayloadDate(event.endDate)
      };
      this.sendSelectedRange.emit(data);
    }
  }

  convertToPayloadDate(date: dayjs.Dayjs) {
    return new Date(date.year(), date.month(), date.date(), 0, 0, 0, 0);
  }
}

